import { TenantJob } from '~/tenants/common/TenantJob';
import { McmOrderContext, McmPerformableConfig } from '~/tenants/mcm/model/McmOrder';
import McmProvider from '~/tenants/mcm/model/McmProvider';
import { mcm_is_crossroads } from '~/tenants/mcm/util';

export default abstract class McmJob<P extends McmPerformableConfig> extends TenantJob<
  McmOrderContext,
  P,
  McmProvider
> {
  protected isCrossroadsPackage(name: 'basic' | 'bronze' | 'silver' | 'gold' | 'platinum') {
    return mcm_is_crossroads(this.order, name);
  }
}
